export default __webpack_public_path__ + "static/media/South Africa.58e99a09.png";